module.exports = __webpack_public_path__ + "img/xinzhuang-1.76965302.jpg";